var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 12,
    fill: "#EAF4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.001 25.9438C27.2939 26.2367 27.2939 26.7115 27.001 27.0044C26.7081 27.2973 26.2333 27.2973 25.9404 27.0044L19.999 21.0631L14.0577 27.0044C13.7648 27.2973 13.2899 27.2973 12.997 27.0044C12.7041 26.7115 12.7041 26.2367 12.997 25.9438L18.9384 20.0024L12.9976 14.0616C12.7047 13.7687 12.7047 13.2938 12.9976 13.0009C13.2905 12.708 13.7653 12.708 14.0582 13.0009L19.999 18.9417L25.9398 13.0009C26.2327 12.708 26.7076 12.708 27.0005 13.0009C27.2934 13.2938 27.2934 13.7687 27.0005 14.0616L21.0597 20.0024L27.001 25.9438Z",
    fill: "#1B1D1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.8ba5a943a9e794ae6a4a42b8903ec5fb.svg";
export { ForwardRef as ReactComponent };